module.exports = __webpack_public_path__ + "static/media/google.7b6b9c18.svg";